<!--<ng-container *ngIf="useWC; then webComponents; else legacyComponents"></ng-container>-->
<!--<ng-template #webComponents>-->
<!--  <lm-dropdown-wc-->
<!--    [layoutObject]="layoutObject"-->
<!--    [mutexSpecField]="mutexSpecField"-->
<!--    [layoutInfo]="layoutInfo"-->
<!--    [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"-->
<!--    [lmColumnLayoutInfo]="lmColumnLayoutInfo"-->
<!--    [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"-->
<!--    [specFields]="specFields"-->
<!--    [placeHolder]="placeHolder"-->
<!--    [model]="model"-->
<!--    (fieldEvent)="onFieldEvent($event)"-->
<!--    (errorOnMemberField)="onMemberFieldError($event)"-->
<!--  ></lm-dropdown-wc>-->
<!--</ng-template>-->
<!--<ng-template #legacyComponents>-->
<lm-dropdown-soho
  [layoutObject]="layoutObject"
  [mutexSpecField]="mutexSpecField"
  [layoutInfo]="layoutInfo"
  [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
  [lmColumnLayoutInfo]="lmColumnLayoutInfo"
  [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
  [specFields]="specFields"
  [placeHolder]="placeHolder"
  [model]="model"
  class="field"
  (fieldEvent)="onFieldEvent($event)"
  (errorOnMemberField)="onMemberFieldError($event)"
></lm-dropdown-soho>
<!--</ng-template>-->
